import {constant} from 'lodash/fp';

import {FETCH_AUTH_EMAIL} from '/enum/launchSequence.enum';
import {readEmail} from '/redux/action/auth.action';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {withProps} from '/util/selector.util';

const fetchAuthEmailTask = {
  stepName: FETCH_AUTH_EMAIL,
  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    withProps({stepName: FETCH_AUTH_EMAIL})(completedStepByName)(state),
  perform: ({dispatch}: any) =>
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(readEmail()).catch(constant(undefined)),
};

export default fetchAuthEmailTask;
